import axios from 'axios/index'

const namespaced = true

const state = {
  appTypes: null
}
const actions = {
  getAppTypes ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/piportals/nova/app-types/'
      })
        .then(response => {
          commit('setAppTypes', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getClient ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.get(data, { responseType: 'blob' })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  setAppTypes (state, value) {
    state.appTypes = value
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
